import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { KartleggingService } from "./KartleggingService";

export const kartleggingResolver: ResolveFn<unknown> = () => {
  return inject(KartleggingService).load();
};
